export enum ContactSupportReason {
    SUBS_SALES = "SUBS_SALES",
    USER_MGMT = "USER_MGMT",
    FIELD_MGMT = "FIELD_MGMT",
    DATA_MODEL = "DATA_MODEL",
    API = "API",
    PORTAL_FEEDBACK = "PORTAL_FEEDBACK",
    OTHER = "OTHER",
}
